import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { API_KEYS_FEATURE_GROUP } from './group';

export const API_KEYS_FEATURES = {
  CREATE: {
    guid: 'e8a4b7c2-9d3f-4e1a-b6c5-2f7d8a9e0000',
    name: 'api_keys:create',
    description: 'Create new API keys for the organization',
    action: 'create',
    product: 'account',
    parentGuid: API_KEYS_FEATURE_GROUP.guid,
  },
  READ: {
    guid: 'e8a4b7c2-9d3f-4e1a-b6c5-2f7d8a9e0001',
    name: 'api_keys:read',
    description: 'View organization API keys and their details',
    action: 'read',
    product: 'account',
    parentGuid: API_KEYS_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'e8a4b7c2-9d3f-4e1a-b6c5-2f7d8a9e0002',
    name: 'api_keys:update',
    description: 'Edit API key name and permissions',
    action: 'update',
    product: 'account',
    parentGuid: API_KEYS_FEATURE_GROUP.guid,
  },
  DELETE: {
    guid: 'e8a4b7c2-9d3f-4e1a-b6c5-2f7d8a9e0003',
    name: 'api_keys:delete',
    description: 'Revoke and delete organization API keys',
    action: 'delete',
    product: 'account',
    parentGuid: API_KEYS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { API_KEYS_FEATURE_GROUP } from './group';

export const API_KEYS_MODULE: FeatureModule = {
  product: 'account',
  groups: [API_KEYS_FEATURE_GROUP],
  features: featureList(API_KEYS_FEATURES),
};
